@if (error) {
<p i18n>Er ging iets fout bij het laden van de content</p>
} @else { }
<ng-template #jitComponentContainer></ng-template>
